import axios from "axios";

import { instance } from "../instance";
import { PATH } from "../../shared/constants";
import { operatorPortalIdTokenHeaders } from "./operatorAdminChat";

export type OperatorHelpTurn = {
  role: "user" | "assistant";
  content: string;
};

export type OperatorHelpLocation = {
  id: string;
  title: string;
  path: string;
  menu: string;
  steps: string[];
  highlight: string;
};

export async function askOperatorHelp(
  viewerEmail: string,
  question: string,
  history: OperatorHelpTurn[],
  image?: { mediaType: string; data: string },
): Promise<{ answer: string; location: OperatorHelpLocation | null }> {
  try {
    const { data } = await instance.post<{
      answer?: string;
      location?: OperatorHelpLocation | null;
    }>(
      `${PATH.API}/${PATH.OPERATOR}/help`,
      { question, history, image },
      {
        params: { email: viewerEmail },
        timeout: 90000,
        ...operatorPortalIdTokenHeaders(),
      },
    );
    const answer = (data?.answer || "").trim();
    if (!answer) throw new Error("Help did not return an answer");
    const location = data?.location && data.location.path
      ? data.location
      : null;
    return { answer, location };
  } catch (err) {
    if (axios.isAxiosError(err)) {
      const body = err.response?.data as { error?: string } | undefined;
      if (typeof body?.error === "string" && body.error.trim()) {
        throw new Error(body.error);
      }
    }
    if (err instanceof Error && err.message) throw err;
    throw new Error("Help could not answer right now");
  }
}
